import React from "react";
import MechanicsList from "../components/MechanicsList";

const MechanicsPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-3xl font-bold text-center mb-6 text-gray-900">Find a Trusted Mechanic near you</h1>
      <p>We have selected the best mechanics of various specialities in all the major towns and cities of Cameroon.These are top-class mechanics who will handle your car in the best way possible. You would reduce your recurrrent visit to the garage with these trusted pros of ours.Check the list below and the select the one that best suits your needs.</p>
      <MechanicsList />
    </div>
  );
};

export default MechanicsPage;